import { ReactElement } from 'react';
import { MediaType } from 'app/shared/components/MediaGallery/utils';
import ImageSlide from 'app/shared/components/MediaGallery/components/MediaSlider/components/ImageSlide/ImageSlide';
import VideoSlide from 'app/shared/components/MediaGallery/components/MediaSlider/components/FullScreenSlides/components/FullScreenList/components/MediaSlide/components/VideoSlide/VideoSlide';

const MediaSlide = ({
  mediaType,
  src,
  type,
  alt,
  original,
  index,
  setIsPlaying,
  offset,
  withBackground,
  isPlaying,
  previewSrc,
}): ReactElement => {
  if (mediaType === MediaType.VIDEO) {
    return (
      <VideoSlide
        src={src}
        type={type}
        previewSrc={previewSrc}
        isPlaying={isPlaying}
        setIsPlaying={setIsPlaying}
        isPaused={offset === index}
      />
    );
  }
  if (mediaType === MediaType.IMAGE) {
    return (
      <ImageSlide
        withBackground={withBackground}
        src={original?.src}
        srcSet={original?.srcSet}
        alt={alt}
      />
    );
  }
  return <span>Media Type not supported.</span>;
};

export default MediaSlide;
